import { fy } from "../../../../date-fns/locale/fy.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    fy
  }
};